import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BookLoader } from "../common/BookLoader";
import DotLoader from "./DotLoader";

const BOOK_MESSAGES = ["closing_chapter", "next_chapter_beginning"];

const isSofestPath = () => {
  if (typeof window === "undefined") return false;
  if (window.location.pathname.startsWith("/sofest")) return true;
  const params = new URLSearchParams(window.location.search);
  return params.get("special") === "sofest";
};

const LoadingView = ({ height, showHoldMessage = false, showCustomMessage = null }) => {
  const showBook = BOOK_MESSAGES.includes(showCustomMessage);
  const sofest = isSofestPath();

  return (
    <Box
      className="LoadingView"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height={height || "100vh"}
      width="100%"
      position="absolute"
      zIndex={1}
      sx={
        sofest
          ? { backgroundColor: "#000", color: "#fff", top: 0, left: 0 }
          : undefined
      }
    >
      {showBook ? <BookLoader /> : sofest ? null : <DotLoader size={40} color="#000000" />}
      {showHoldMessage && <HoldMessage />}
      {showCustomMessage && <ShowCustomMessage customMessage={showCustomMessage} />}
    </Box>
  );
};

const HoldMessage = () => {
  const { t } = useTranslation();

  return (
    <p style={{ marginTop: "1rem" }}>
      {t("please_hold")}
    </p>
  );
};

const ShowCustomMessage = ({ customMessage }) => {
  const { t } = useTranslation();

  return (
    <p style={{ fontWeight: "500", fontStyle: "italic" }}>
      {t(customMessage)}
    </p>
  );
};

export default LoadingView;
